import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PhoneIcon from '@mui/icons-material/Phone';

const CTABanner = () => (
  <Box sx={{
    bgcolor: '#020d1a',
    py: { xs: 8, md: 10 },
    position: 'relative', overflow: 'hidden',
    borderTop: '1px solid rgba(16,185,129,0.2)',
  }}>
    {/* Neon pulse effect */}
    <Box sx={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(16,185,129,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(16,185,129,0.03) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
    <Box sx={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(16,185,129,0.1) 0%, transparent 55%)', bottom: -300, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none' }} />

    <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={8} sx={{ textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Box sx={{ width: 72, height: 72, borderRadius: '20px', bgcolor: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FingerprintIcon sx={{ fontSize: 40, color: '#10b981' }} />
            </Box>
          </Box>
          <Typography variant="h2" sx={{ color: '#fff', fontWeight: 900, mb: 2, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '3rem' }, lineHeight: 1.2 }}>
            Stop Losing Money to{' '}
            <Box component="span" sx={{ background: 'linear-gradient(90deg, #10b981, #34d399)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Payroll Errors
            </Box>
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 17, mb: 5, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
            1,000+ businesses across India trust SN Info Systems' Biometric Payroll System to manage attendance without fraud and process payroll without errors.
          </Typography>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button variant="contained" size="large"
                sx={{ bgcolor: '#059669', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 16, boxShadow: '0 8px 32px rgba(5,150,105,0.5)', '&:hover': { bgcolor: '#047857', transform: 'translateY(-2px)' } }}>
                Book Free Demo
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" startIcon={<PhoneIcon />} size="large"
                sx={{ borderColor: 'rgba(16,185,129,0.4)', color: '#34d399', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 700, '&:hover': { borderColor: '#10b981', bgcolor: 'rgba(16,185,129,0.05)' } }}>
                +91 97408 57368
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default CTABanner;
